import { splitTicketQuotesFromEditorHtml } from '~/utils/salesforce/splitTicketQuotesFromEditorHtml';

/**
 * Converts editor HTML to a plain-text fallback for Salesforce TextBody.
 */
export function richTextToPlain(html: string | null | undefined): string {
  if (!html) {
    return '';
  }

  return html
    .replace(
      /<strong class="ticket-quote__header"[^>]*>([\s\S]*?)<\/strong>/gi,
      '$1\n\n'
    )
    .replace(/<span class="ticket-quote__body"[^>]*>/gi, '\n')
    .replace(/<span class="ticket-quote__line"[^>]*>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function isRichTextEmpty(html: string | null | undefined): boolean {
  return richTextToPlain(html).length === 0;
}

function stripTicketQuoteBlockquotes(html: string): string {
  return html.replace(
    /<blockquote\b(?=[^>]*(?:data-quote-source=["'](?:customer|support)["']|class=["'][^"']*\bticket-quote\b))[^>]*>[\s\S]*?<\/blockquote>/gi,
    ''
  );
}

function stripTicketQuotesFromHtml(html: string): string {
  if (!html.includes('ticket-quote') && !html.includes('data-quote-source')) {
    return html;
  }

  if (typeof DOMParser !== 'undefined') {
    return splitTicketQuotesFromEditorHtml(html).editorHtml;
  }

  return stripTicketQuoteBlockquotes(html);
}

/** Plain text of the reply excluding quoted timeline content. */
export function richTextToPlainReplyComment(
  html: string | null | undefined
): string {
  return richTextToPlain(stripTicketQuotesFromHtml(html ?? ''));
}

export function isTicketReplyCommentEmpty(
  html: string | null | undefined
): boolean {
  return richTextToPlainReplyComment(html).trim().length === 0;
}
